import React from 'react';
import Container from './styled';

interface LegendTagProps {
  name: string;
  color: string;
}

const LegendTag = ({ name, color }: LegendTagProps) => (
  <Container bg={color}>
    <p>{name}</p>
  </Container>
);

export default LegendTag;
